import {AfterViewInit, Component, Directive, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';
import {BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {UploadFileComponent} from '../../../ui/upload/uploadfile.component';
import {environment} from '../../../../../environments/environment';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {ConfirmDialogComponent} from '../../../dialog/confirmdialog.component';
import {language} from '../../../../language/vn';
import {VanBanDenService} from '../../../../service/vanbanden/service-vanbanden';
import {VanBanDen} from '../../../../models/vanbanden/vanbanden';
import {EditVanBanDenComponent} from '../soanvanban/edit.component';
import {CommandUtil} from '../../../../global/commandutil';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {GXLVanBanDenComponent} from '../giaoxuly/giaoxuly.component';
import {ChenHoSoVanBanDenComponent} from '../chenhoso/chenhoso.component';
import {PdfShowComponent} from '../../view/pdf.component';
import {VanBanDenFileService} from '../../../../service/vanbanden/service-vanbandenfile';
import {FormatService} from '../../../../service/format/service-format';
import {DatePipe} from '@angular/common';
import {LoaiVanBanService} from '../../../../service/danhmuc/service-loaivanban';
import {LoaiVanBan} from '../../../../models/danhmuc/loaivanban';

@Component({
  templateUrl: './phocap.component.html',

})
export class PhoCapVanBanDenComponent implements OnInit, AfterViewInit {
  @ViewChild('largeModal')
  public largeModal: ModalDirective;
  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  public language = language;
  public totalItems: number = 0;
  public hoSoId:  number;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public frmGroup: FormGroup;
  public isEdit: boolean = false;
  public dataList: VanBanDen[];
  public submitValidate = false;
  public totalDaPhoCap: number =0;
  public totalChuaPhoCap: number =0;
  public totalItemsReal: number= 0;

  public srTuKhoa: string = '';
  public srStatus: string ='';
  public status: number[] = [
   -1
  ];
  public phoCap: number = -1;
  public nguoiNhapId: number = Sessioncommand.staffId;
  public nguoiChuTri: number =-1;
  public maNoiGui: number =-1;
  public checked: boolean = false;
  public dataCheck: Object[]=[];
  public srFromDate: Date ;
  public srToDate: Date;
  public strF: string= '';
  public strT: string= '';
  public dataLoaiVanBan: LoaiVanBan[] = [];
  public srLoaiVanBan: number =-1;
  public srLinhVucVanBan: number =-1;
  constructor(
    public vanBanDenService: VanBanDenService,
    public formBuilder: FormBuilder,
    public toastr: ToastrService,
    public bsModalService: BsModalService,
    public vanBanDenFileService: VanBanDenFileService,
     public commandUtil: CommandUtil,
    public formatService: FormatService,
    public datePipe: DatePipe,
    public loaiVanBanService: LoaiVanBanService
  ) {
  }
  ngAfterViewInit() {

  }
  public checkedItem(event)
  {

    if(event.target.checked== true && this.dataCheck.indexOf(event.target.value) ==-1)
      this.dataCheck.push(event.target.value);
    else
       this.commandUtil.removeItem(event.target.value, this.dataCheck);
    if(this.dataCheck.length==0)
      this.checked=false;
  }
  public checkAll(event)
  {
    this.dataCheck=[];
    this.checked= event.target.checked;
    if(event.target.checked == true)
    {
      for(let i=0;i< this.dataList.length;i++)
        this.dataCheck.push(this.dataList[i].id);
    }
  }
  ngOnInit(): void {
    this.srStatus = this.status.join();
    this.loadTotal();
    this.search();
    this.loaiVanBanService.getAll().subscribe(data => this.dataLoaiVanBan = data);

  }
  public summitActive(phoCap: number)
  {

    if(this.dataCheck.length==0)
    {
      this.toastr.error((phoCap == 1 ? language.message_warning_phocap : language.message_warning_huyphocap), language.message);
    }else
    {
      const modal = this.bsModalService.show(ConfirmDialogComponent);
      (<ConfirmDialogComponent>modal.content).showConfirmationModal(
        language.message,
        (phoCap == 1 ? language.questionphocap : language.questionhuyphocap),
        language.yes,
        language.no
      );
      (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
        if (result === true) {
          this.vanBanDenService.changePhoCap(this.dataCheck.join(), phoCap
          ).subscribe(
            {    next: (data) => {
                this.toastr.success((phoCap == 1 ? language.messagephocap : language.messagehuyphocap), language.message);
                this.search();
              },
              error: error => {
                this.toastr.error(language.error, language.message);
              }
            });
        }
      });
    }

  }
  showFile(id: number) {
    this.vanBanDenFileService.findAllByVanBanId(id).subscribe( x=>{
      if(x.length>0)
      {
        const modalEdit = this.bsModalService.show(PdfShowComponent, {class: 'modal-lg'});
        (<PdfShowComponent>modalEdit.content).show(
          this.commandUtil.getUrlDownload(x[0].folder, x[0].fileKey, x[0].width, x[0].name)

        );
        (<PdfShowComponent>modalEdit.content).onClose.subscribe(result => {
          if (result === true) {
            this.search();
          }
        });
      }
    });


  }
  public loadTotal()
  { this.strF = this.datePipe.transform(this.srFromDate, 'MM/dd/yyyy');
    this.strT =  this.datePipe.transform(this.srToDate, 'MM/dd/yyyy');
    this.vanBanDenService.getCountByKeyword(this.srTuKhoa, this.srLoaiVanBan, this.srLinhVucVanBan, this.srStatus, CommandUtil.daPhoCap, this.nguoiNhapId, this.nguoiChuTri, this.maNoiGui, this.strF, this.strT).subscribe(recordCount => this.totalDaPhoCap = recordCount);
    this.vanBanDenService.getCountByKeyword(this.srTuKhoa, this.srLoaiVanBan, this.srLinhVucVanBan, this.srStatus, CommandUtil.chuaPhoCap, this.nguoiNhapId, this.nguoiChuTri, this.maNoiGui, this.strF, this.strT).subscribe(recordCount => this.totalChuaPhoCap = recordCount);
    this.vanBanDenService.getCountByKeyword(this.srTuKhoa, this.srLoaiVanBan, this.srLinhVucVanBan, this.srStatus, CommandUtil.defaultValue, this.nguoiNhapId, this.nguoiChuTri, this.maNoiGui, this.strF, this.strT).subscribe(recordCount => this.totalItemsReal = recordCount);
  }
  search()
  {

    this.strF = this.datePipe.transform(this.srFromDate, 'MM/dd/yyyy');
    this.strT =  this.datePipe.transform(this.srToDate, 'MM/dd/yyyy');
    this.vanBanDenService.findAllByPaging(this.srTuKhoa,
      this.srLoaiVanBan, this.srLinhVucVanBan,
      this.srStatus,
      this.phoCap,
      this.nguoiNhapId,
      this.nguoiChuTri,
      this.maNoiGui, this.strF, this.strT,
      this.currentPage, this.maxSize).subscribe(dataList => this.dataList = dataList);
    this.vanBanDenService.getCountByKeyword(this.srTuKhoa,
      this.srLoaiVanBan, this.srLinhVucVanBan,
      this.srStatus,
      this.phoCap,
      this.nguoiNhapId,
      this.nguoiChuTri,
      this.maNoiGui, this.strF, this.strT).subscribe(recordCount => this.totalItems = recordCount);
  }

  public changePhoCap(id: number, phoCap: number)
  {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      (phoCap == 1 ? language.questionphocap : language.questionhuyphocap),
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.vanBanDenService.changePhoCap(id.toString(), phoCap
        ).subscribe(
          {    next: (data) => {
              this.toastr.success((phoCap == 1 ? language.messagephocap : language.messagehuyphocap), language.message);
              this.search();
              Sessioncommand.vanBanDenStatus = 0;
            },
            error: error => {
              this.toastr.error(language.error, language.message);
            }
          });
      }
    });
  }
  deleteItem(id: number)
  {
    this.vanBanDenService.delete(id).subscribe({
      next: () => {
        this.toastr.success(language.delete_success_record, language.message);
        this.search();
        Sessioncommand.vanBanDenStatus = 0;

      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();

  }

}

